export default __webpack_public_path__ + "1fb244c8ab7131629ddcc42988caf151.svg";